var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.newInbox
        ? _c(
            "div",
            { staticClass: "d-block d-sm-none" },
            [
              _c("router-link", { attrs: { to: "/inbox" } }, [
                _c("div", { staticClass: "row section-notification" }, [
                  _c("div", { staticClass: "col-12 text-center" }, [
                    _c("i", { staticClass: "fas fa-envelope" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.home.you_got_new_message")) +
                        "\n          "
                    ),
                    _c("svg", { staticClass: "notification-alert" }, [
                      _c("circle", { attrs: { cx: "3", cy: "3", r: "3" } })
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "section-hero", class: { "p-4": _vm.$mq.phone } },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-8 col-12 hero-content" }, [
              _c("div", { staticClass: "hero-title" }, [
                _vm._v(_vm._s(_vm.$t("message.hero.title")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hero-sub-title" }, [
                _vm._v(_vm._s(_vm.$t("message.hero.sub_title")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hero-action-button mt-2" },
                [
                  _vm.user
                    ? [
                        _vm.hasCompletedOrders
                          ? _c(
                              "router-link",
                              {
                                staticClass: "button-large -cyan mr-2 mt-1",
                                attrs: { to: "/cleaners", tag: "button" }
                              },
                              [
                                _c("img", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    src: "/static/img/hero/book_my_cleaner.png",
                                    width: "24"
                                  }
                                }),
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.hero.book_my_cleaner")
                                  ) + "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "button-large mr-2 mt-1",
                            class: [
                              _vm.hasCompletedOrders
                                ? "button-outline-white"
                                : "-cyan"
                            ],
                            attrs: { to: "/booking/start", tag: "button" }
                          },
                          [
                            _vm.hasCompletedOrders
                              ? _c("img", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    src:
                                      "/static/img/hero/find_new_cleaner.png",
                                    width: "24"
                                  }
                                })
                              : _c("img", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    src: "/static/img/hero/action_button.png",
                                    width: "24"
                                  }
                                }),
                            _vm._v(
                              _vm._s(_vm.$t("message.hero.find_new_cleaner")) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "button-large -line-green mt-1",
                            attrs: {
                              href: "https://line.me/R/ti/p/%40hnk7011n"
                            }
                          },
                          [
                            _vm._v("\n               "),
                            _c("img", {
                              staticClass: "mr-2",
                              attrs: {
                                src: "/static/img/hero/chat.png",
                                width: "24"
                              }
                            }),
                            _vm._v(
                              _vm._s(_vm.$t("message.hero.chat")) +
                                " \n            "
                            )
                          ]
                        )
                      ]
                    : [
                        _c(
                          "div",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "button-large -cyan mr-2 mt-1 mb-0",
                                attrs: { to: "/booking/start", tag: "a" }
                              },
                              [
                                _vm._v("\n                 "),
                                _c("img", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    src: "/static/img/hero/action_button.png",
                                    width: "24"
                                  }
                                }),
                                _vm._v(
                                  _vm._s(_vm.$t("message.hero.action_button")) +
                                    " \n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button-large -line-green mt-1 mb-0",
                                attrs: {
                                  href: "https://line.me/R/ti/p/%40hnk7011n"
                                }
                              },
                              [
                                _vm._v("\n                 "),
                                _c("img", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    src: "/static/img/hero/chat.png",
                                    width: "24"
                                  }
                                }),
                                _vm._v(
                                  _vm._s(_vm.$t("message.hero.chat")) +
                                    " \n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "hero-login-text mt-3" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("message.hero.or")) +
                              " \n              "
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openLoginModal.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("message.hero.login_beneat"))
                              )
                            ]
                          )
                        ])
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-left d-none d-sm-block mt-4" }, [
                _c("ul", { staticClass: "hero-list list-unstyled" }, [
                  _c("li", [
                    _c("i", { staticClass: "fas fa-check text-primary" }),
                    _vm._v(
                      "  " +
                        _vm._s(_vm.$t("message.hero.feature01")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("i", { staticClass: "fas fa-check text-primary" }),
                    _vm._v(
                      "  " +
                        _vm._s(_vm.$t("message.hero.feature02")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("i", { staticClass: "fas fa-check text-primary" }),
                    _vm._v(
                      "  " +
                        _vm._s(_vm.$t("message.hero.feature03")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("i", { staticClass: "fas fa-check text-primary" }),
                    _vm._v(
                      "  " +
                        _vm._s(_vm.$t("message.hero.feature04")) +
                        "\n            "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hero-download-app" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("message.hero.download_app")))]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" \n          "),
                _vm._m(1)
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("user-coins-points"),
      _vm._v(" "),
      _c("promotion-slider", { attrs: { perPage: _vm.$mq.phone ? 1 : 3 } }),
      _vm._v(" "),
      _c("section", { staticClass: "mt-2" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-6 col-lg-4" },
            [
              _c(
                "router-link",
                {
                  staticClass: "no-style",
                  attrs: { to: "/booking/new", tag: "a" }
                },
                [
                  _c("div", { staticClass: "card shadow-sm" }, [
                    _c("div", { staticClass: "card-body p-0 d-flex" }, [
                      _c(
                        "div",
                        { staticClass: "menu-icon text-center -menu" },
                        [
                          _c("img", {
                            attrs: {
                              src: "/static/img/ic-select-cleaner.svg",
                              alt: "",
                              width: "50"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "justify-content-center align-self-center mx-3"
                        },
                        [
                          _c("h3", { staticClass: "menu-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.menu.search_professionals")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.menu.search_professionals_detail"
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ])
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-md-6 col-lg-4" },
            [
              _c(
                "router-link",
                {
                  staticClass: "no-style",
                  attrs: {
                    to: "/special-services/search?service_id=7",
                    tag: "a"
                  }
                },
                [
                  _c("div", { staticClass: "card shadow-sm" }, [
                    _c("div", { staticClass: "card-body p-0 d-flex" }, [
                      _c(
                        "div",
                        { staticClass: "menu-icon text-center -accepted" },
                        [
                          _c("img", {
                            attrs: {
                              src: "/static/img/ic-select-therapist.svg",
                              alt: "",
                              width: "50"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "justify-content-center align-self-center mx-3"
                        },
                        [
                          _c("h3", { staticClass: "menu-title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("message.menu.search_therapists"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.menu.search_therapists_detail")
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "section-padding-home section-services" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h3", { staticClass: "home-title" }, [
              _vm._v(_vm._s(_vm.$t("message.home.popular_services")))
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mt-2" },
          [
            _vm._l(_vm.sortedServices, function(service, index) {
              return [
                service.parent_id === 0 &&
                service.service_type === "popular" &&
                service.is_hidden === 0
                  ? _c(
                      "div",
                      {
                        staticClass: "col-lg-3 col-4 pb-3 text-center",
                        class: { "pb-3": _vm.$mq.phone }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "no-style",
                            attrs: { to: service.route_url, tag: "a" }
                          },
                          [
                            _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-image" }, [
                                _c("img", {
                                  attrs: { src: service.picture, alt: "" }
                                })
                              ])
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm._f("multiLangName")(service)) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-3" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h3", { staticClass: "home-title" }, [
              _vm._v(_vm._s(_vm.$t("message.home.subscription_service")))
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mt-2" },
          _vm._l(_vm.globalState.subscriptionServices, function(
            subscriptionService,
            index
          ) {
            return _c(
              "div",
              {
                staticClass: "col-lg-3 col-6 text-center",
                class: { "pb-3": _vm.$mq.phone }
              },
              [
                index === 0
                  ? _c(
                      "router-link",
                      {
                        staticClass: "no-style",
                        attrs: {
                          to: "/booking/start?subscriptionTypeId=1",
                          tag: "a"
                        }
                      },
                      [
                        _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-image" }, [
                            _c("img", {
                              directives: [
                                {
                                  name: "lazy",
                                  rawName: "v-lazy",
                                  value: subscriptionService.picture,
                                  expression: "subscriptionService.picture"
                                }
                              ],
                              attrs: { alt: "" }
                            })
                          ])
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("multiLangName")(subscriptionService)
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "row mt-3 d-flex justify-content-start align-items-center"
          },
          [
            _c("div", { staticClass: "col-6" }, [
              _c("h3", { staticClass: "home-title mb-0" }, [
                _vm._v(_vm._s(_vm.$t("message.home.specialty_services")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-primary-link",
                    attrs: { to: "/special-services/search" }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.home.view_specialty_services")) +
                        " "
                    ),
                    _c("i", { staticClass: "far fa-angle-right" })
                  ]
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mt-2" },
          [
            _vm._l(_vm.sortedServices, function(service, index) {
              return [
                service.parent_id === 0 &&
                service.service_type === "special" &&
                service.is_hidden === 0
                  ? _c(
                      "div",
                      {
                        staticClass: "col-lg-3 col-4 pb-3 text-center",
                        class: { "pb-3": _vm.$mq.phone }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "no-style",
                            attrs: { to: _vm.getServiceUrl(service), tag: "a" }
                          },
                          [
                            _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-image" }, [
                                _c("img", {
                                  attrs: { src: service.picture, alt: "" }
                                })
                              ])
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm._f("multiLangName")(service)) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("section", [_c("review-by-user")], 1),
        _vm._v(" "),
        _vm._m(2)
      ]),
      _vm._v(" "),
      _c("recommend-professionals", { attrs: { provinceId: 1 } }),
      _vm._v(" "),
      _c("recommend-professionals", { attrs: { provinceId: 2 } }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("section", { staticClass: "section-padding-home section-solution" }, [
        _c("h2", { staticClass: "text-center" }, [
          _vm._v(_vm._s(_vm.$t("message.home.solution_title")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 text-lg-center text-sm-left" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("message.home.solution_detail")))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-lg-4 mt-2" }, [
          _c("div", { staticClass: "col-lg-4 col-12 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/cleaning-equipment.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "mt-3" }, [
              _vm._v(_vm._s(_vm.$t("message.home.solution_title01")))
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("message.home.solution_detail01")))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-12 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/select-user.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "mt-3" }, [
              _vm._v(_vm._s(_vm.$t("message.home.solution_title02")))
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("message.home.solution_detail02")))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-12 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/protect.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "mt-3" }, [
              _vm._v(_vm._s(_vm.$t("message.home.solution_title03")))
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("message.home.solution_detail03")))]),
            _vm._v(" "),
            _c("p", { staticClass: "text-remark" }, [
              _vm._v(_vm._s(_vm.$t("message.home.solution_detail03_remark")))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "section-cleaner section-padding-gray" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _vm._v("\n          \n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("h2", [
              _vm._v(_vm._s(_vm.$t("message.home.who_is_your_cleaner")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.home.who_is_your_cleaner_detail")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-4" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-primary-link",
                    attrs: { to: "/about-the-cleaners" }
                  },
                  [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("message.home.learn_more")))
                    ])
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "section-padding" }, [
        _c("h2", { staticClass: "text-center" }, [
          _vm._v(_vm._s(_vm.$t("message.home.how_it_works")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-lg-4 col-12 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/calendar-time.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "mt-3" }, [
              _vm._v(_vm._s(_vm.$t("message.home.how_it_works_title01")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.home.how_it_works_detail01")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-12 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/confirm.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "mt-3" }, [
              _vm._v(_vm._s(_vm.$t("message.home.how_it_works_title02")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.home.how_it_works_detail02")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-12 text-center" }, [
            _c("img", {
              attrs: { src: "/static/img/cleaner.svg", width: "60" }
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "mt-3" }, [
              _vm._v(_vm._s(_vm.$t("message.home.how_it_works_title03")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("message.home.how_it_works_detail03")))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("section", { staticClass: "section-mobile section-padding" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-7" }, [
            _c("h2", [_vm._v(_vm._s(_vm.$t("message.home.mobile_title")))]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-feature" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("p"),
              _c("h3", [_vm._v(_vm._s(_vm.$t("message.home.mobile_title01")))]),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.home.mobile_detail01")) +
                  "\n          "
              ),
              _c("p")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-feature" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("p"),
              _c("h3", [_vm._v(_vm._s(_vm.$t("message.home.mobile_title02")))]),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.home.mobile_detail02")) +
                  "\n          "
              ),
              _c("p")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-feature" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("p"),
              _c("h3", [_vm._v(_vm._s(_vm.$t("message.home.mobile_title03")))]),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.home.mobile_detail03")) +
                  "\n          "
              ),
              _c("p")
            ]),
            _vm._v(" "),
            _vm._m(6)
          ]),
          _vm._v(" "),
          _vm._m(7)
        ])
      ]),
      _vm._v(" "),
      _c("section-partner"),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "section-apply-cleaner section-padding-gray" },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "div",
                { staticClass: "apply-professionals-content" },
                [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("message.apply.title")))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("message.apply.sub_title")))]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("message.apply.supported_by")))
                  ]),
                  _vm._v(" "),
                  _vm._m(8),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "button button-large -yellow mt-2",
                      attrs: { to: "/apply", tag: "button" }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.button.apply_cleaner")) +
                          "\n          "
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _vm._v("\n         \n      ")
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://itunes.apple.com/th/app/beneat/id1203611695?mt=8",
          target: "_blank"
        }
      },
      [
        _c("img", {
          attrs: {
            height: "36",
            alt: "BeNeat iOS App",
            src: "/static/img/btn-app-store.svg"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://play.google.com/store/apps/details?id=com.beneat.app",
          target: "_blank"
        }
      },
      [
        _c("img", {
          attrs: {
            height: "36",
            alt: "BeNeat Android App",
            src: "/static/img/btn-play-store.svg"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "a",
          {
            attrs: { href: "https://line.me/R/ti/p/@BeNeat", target: "_blank" }
          },
          [
            _c("img", {
              staticClass: "img-fluid rounded d-none d-sm-block",
              attrs: { src: "/static/img/beneat-package.png", alt: "" }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "img-fluid rounded d-block d-sm-none",
              attrs: { src: "/static/img/beneat-package-sm.jpg", alt: "" }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "far fa-paper-plane text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "far fa-bell text-primary" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "far fa-comment-dots text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mobile-app-download" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://itunes.apple.com/th/app/beneat/id1203611695?mt=8",
            target: "_blank"
          }
        },
        [
          _c("img", {
            staticClass: "img-app-download",
            attrs: { src: "/static/img/btn-app-store.svg" }
          })
        ]
      ),
      _vm._v("\n              \n          "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://play.google.com/store/apps/details?id=com.beneat.app",
            target: "_blank"
          }
        },
        [
          _c("img", {
            staticClass: "img-app-download",
            attrs: { src: "/static/img/btn-play-store.svg" }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-5 d-none d-md-block text-center" },
      [
        _c("img", {
          attrs: { src: "/static/img/beneat-app.png", height: "420" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-3" }, [
      _c("img", {
        attrs: { src: "/static/img/business-customer14.png", width: "360" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1497
// module chunks = 0